import axios from "axios";

export default function request_api() {
  let http_axios = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 30000, // 30 detik
  });
  return http_axios;
}
